import { CropSubcategory } from "@/generated/digitalnisklady.cz/graphql";

import { subcategoryToSlug } from "../marketplace-subcategory.utils";
import { NavigationCard } from "./navigation-card";

const SubcategoryCard = ({
  label,
  subcategory,
}: {
  label: string;
  subcategory: CropSubcategory;
}) => {
  const slug = subcategoryToSlug(subcategory);

  return <NavigationCard id={subcategory} label={label} to={slug} />;
};

export { SubcategoryCard };
